import {
  DocumentCardChrome,
  DocumentTile,
  DocumentTileFooterBadge,
  getFileTypeBadge,
} from "@mytour/documents";
import {downloadService} from "@mytour/platform";
import type {InvoiceDocument} from "@mytour/shared";
import {useState} from "react";
import {toast} from "react-toastify";
import {invoiceDocumentApiService} from "../query/invoiceDocumentApi.service";

const PDF_BADGE = getFileTypeBadge("application/pdf");

export function InvoiceCard({doc}: {doc: InvoiceDocument}) {
  const [isDownloading, setIsDownloading] = useState(false);
  const label = doc.kind === "credit" ? "Avoir" : "Facture";
  return (
    <DocumentCardChrome>
      <div
        role="button"
        tabIndex={0}
        onClick={handleDownload}
        onKeyDown={handleKeyDown}
        aria-disabled={isDownloading}
        style={{cursor: isDownloading ? "wait" : "pointer"}}
      >
        <DocumentTile
          thumb={{kind: "badge", label: PDF_BADGE.label, color: PDF_BADGE.color}}
          title={`${label} n° ${doc.invoiceNumber}`}
          subtitle={null}
          footer={<DocumentTileFooterBadge label={label} />}
        />
      </div>
    </DocumentCardChrome>
  );

  function handleKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleDownload();
    }
  }

  async function handleDownload() {
    if (isDownloading) {
      return;
    }
    try {
      setIsDownloading(true);
      const blob = await invoiceDocumentApiService.downloadFile(doc.id);
      await downloadService.download(blob, doc.fileName);
    } catch {
      toast.error("Impossible de télécharger le document.");
    } finally {
      setIsDownloading(false);
    }
  }
}
